export const PERMISSIONS = Object.freeze([
  "project.members.read",
  "project.members.manage",
  "project.groups.manage",
  "project.audit.read",
  "rfi.workflow.manage",
  "library.read",
  "document.preview",
  "document.share",
  "document.history.read",
  "document.original.download",
  "document.package.read",
  "document.package.download",
  "document.create",
  "upload.request.create",
  "upload.review",
  "revision.create",
  "document.meta.edit",
  "revision.label.edit",
  "revision.status.edit",
  "revision.current.set",
  "document.move",
  "document.archive",
  "document.restore",
  "revision.purge",
  "archive.read",
  "archive.purge",
  "archive.purge_all",
  "catalog.export",
  "catalog.import.preview",
  "catalog.import.apply",
  "project.create",
  "project.rename",
  "project.delete",
  "project.purge",
  "folder.create",
  "folder.rename",
  "folder.move",
  "folder.delete",
  "folder.purge",
  "rfi.read",
  "rfi.create",
  "rfi.update",
  "rfi.delete",
  "rfi.reply",
  "annotation.read",
  "annotation.create",
  "annotation.update",
  "annotation.delete",
  "annotation.resolve",
  "annotation.reply",
  "annotation.clear",
  "viewpoint.read",
  "viewpoint.create",
  "viewpoint.update",
  "viewpoint.delete",
  "review.calibration.edit",
  "review.floors.edit",
  "workspace.read",
  "workspace.links.edit",
  "workspace.models.edit",
  "workspace.scale.edit",
  "bim.properties.read",
  "bim.levels.read",
  "conversion.read",
  "conversion.request",
  "conversion.batch",
  "conversion.stateless",
  "system.status.read",
  "library.usage.read",
  "library.clear",
  "users.manage",
  "roles.manage",
  "role_bindings.manage",
  "audit.read"
]);

/** 角色只勾這些控制項。儲存時展開成底下的控制點，避免漏掉連在一起的功能。 */
export const CONTROLS = Object.freeze([
  {id: 'drawing.view', group: '圖說', title: '檢視圖說', desc: '瀏覽目錄與清冊、開啟圖面、查看歷程、ZIP 清單、轉檔狀態、BIM 屬性，以及讀取共享檢視設定', actions: ['library.read', 'document.preview', 'document.history.read', 'document.package.read', 'conversion.read', 'bim.properties.read', 'bim.levels.read', 'workspace.read']},
  {id: 'drawing.share', group: '圖說', title: '分享給外包', desc: '建立或停止單一版次的外部檢視連結。對方不需登入，只能看這一版並留下自己的釋疑', actions: ['document.share']},
  {id: 'drawing.download', group: '圖說', title: '下載原檔', desc: '下載原始圖檔、附件與原始 ZIP', actions: ['document.original.download', 'document.package.download']},
  {id: 'drawing.edit', group: '圖說', title: '維護圖說', desc: '提交上傳審核單、新增版次、修改圖說資料與版次、指定現行版、搬移，以及封存與還原', actions: ['upload.request.create', 'document.create', 'revision.create', 'document.meta.edit', 'revision.label.edit', 'revision.status.edit', 'revision.current.set', 'document.move', 'document.archive', 'document.restore']},
  {id: 'drawing.purge', group: '圖說', title: '刪除版次', desc: '永久刪除單一版次', actions: ['revision.purge']},
  {id: 'structure.edit', group: '目錄與清冊', title: '目錄結構', desc: '新增、改名、搬移與刪除專案和子目錄', actions: ['project.create', 'project.rename', 'project.delete', 'project.purge', 'folder.create', 'folder.rename', 'folder.move', 'folder.delete', 'folder.purge']},
  {id: 'catalog.edit', group: '目錄與清冊', title: '圖說清冊', desc: '匯出 CSV，並預覽後寫入清冊', actions: ['catalog.export', 'catalog.import.preview', 'catalog.import.apply']},
  {id: 'archive.manage', group: '封存', title: '封存匣', desc: '查看封存、永久刪除選定文件與清空封存匣', actions: ['archive.read', 'archive.purge', 'archive.purge_all']},
  {id: 'rfi.edit', group: '協作', title: '釋疑', desc: '閱讀、新增、修改與刪除釋疑，含模型與 PDF／圖片頁面的標點、雲狀圖、箭頭、手繪、文字與方框', ownership: true, actions: ['rfi.read', 'rfi.create', 'rfi.update', 'rfi.delete']},
  {id: 'rfi.discuss', group: '協作', title: '釋疑回覆', desc: '在授權檔案的同一條釋疑內新增回覆內容，不授予修改或刪除他人提問的權限', actions: ['rfi.reply']},
  {id: 'rfi.manage', group: '協作', title: '釋疑流程管理', desc: '在授權範圍內指派、設定期限、退回及結案，不授予修改提問或刪除權限', actions: ['rfi.workflow.manage']},
  {id: 'annotation.edit', group: '協作', title: '標註', desc: '查看、新增、修改、結案、回覆、刪除與清空標註', ownership: true, actions: ['annotation.read', 'annotation.create', 'annotation.update', 'annotation.delete', 'annotation.resolve', 'annotation.reply', 'annotation.clear']},
  {id: 'viewpoint.edit', group: '協作', title: '書籤與對位', desc: '視點書籤，以及尺度、樓層、圖面關聯與模型疊合', ownership: true, actions: ['viewpoint.read', 'viewpoint.create', 'viewpoint.update', 'viewpoint.delete', 'review.calibration.edit', 'review.floors.edit', 'workspace.links.edit', 'workspace.models.edit', 'workspace.scale.edit']},
  {id: 'conversion.run', group: '轉檔', title: '轉檔', desc: '單檔重轉、目錄批次轉檔，以及不進圖庫的轉換', actions: ['conversion.request', 'conversion.batch', 'conversion.stateless']},
  {id: 'system.observe', group: '系統', title: '引擎與圖庫', desc: '查看引擎狀態、授權、快取、路徑與圖庫用量', actions: ['system.status.read', 'library.usage.read']},
  {id: 'library.clear', group: '系統', title: '清空圖庫', desc: '清空圖庫、未分類或指定目錄', actions: ['library.clear']},
]);

const covered = CONTROLS.flatMap(control => control.actions);
if (new Set(covered).size !== covered.length) throw new Error('控制項含有重複的控制點');

export const OWNABLE_ACTION = /^(?:(rfi|annotation|viewpoint)\.(update|delete|resolve)|(annotation|viewpoint)\.reply)$/;

/** 把角色勾選的控制項展開成控制點。可設本人條件的動作沿用該控制項的 own／any。 */
export function expandControls(items) {
  const out = [];
  const seen = new Set();
  for (const item of items) {
    const control = CONTROLS.find(entry => entry.id === item?.control);
    if (!control) continue;
    const ownership = item.ownership === 'own' ? 'own' : 'any';
    for (const action of control.actions) {
      if (seen.has(action)) continue;
      seen.add(action);
      out.push({action, ownership: OWNABLE_ACTION.test(action) ? ownership : 'any'});
    }
  }
  if(seen.has('rfi.reply')&&!seen.has('rfi.read'))out.push({action:'rfi.read',ownership:'any'});
  return out;
}

/** 既有角色若只勾到控制項的一部分，補齊同一控制項的其餘控制點。 */
export function completeControlPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.some(item => item?.action === '*')) return permissions;
  const have = new Map(permissions.filter(item => item?.action).map(item => [item.action, item]));
  let changed = false;
  for (const control of CONTROLS) {
    const present = control.actions.filter(action => have.has(action));
    // Reading/discussing an RFI must never turn into editing its question.
    if(control.id==='rfi.edit'&&!present.some(a=>['rfi.create','rfi.update','rfi.delete'].includes(a)))continue;
    if(control.id==='rfi.discuss'&&!have.has('rfi.reply'))continue;
    if (!present.length || present.length === control.actions.length) continue;
    const ownership = present.some(action => have.get(action).ownership === 'own') ? 'own' : 'any';
    for (const action of control.actions) {
      if (have.has(action)) continue;
      have.set(action, {action, ownership: OWNABLE_ACTION.test(action) ? ownership : 'any'});
      changed = true;
    }
  }
  if(have.has('rfi.reply')&&!have.has('rfi.read')){have.set('rfi.read',{action:'rfi.read',ownership:'any'});changed=true;}
  return changed ? [...have.values()] : permissions;
}

export const PERMISSION_LABELS = Object.freeze({
  "library.read": "瀏覽目錄、清冊、搜尋及文件資料",
  "document.preview": "開啟 2D／3D／PDF／圖片",
  "document.share": "建立或停止外包分享連結",
  "document.history.read": "查閱及開啟非現行版",
  "document.original.download": "下載原始檔／附件",
  "document.package.read": "查看 ZIP 清單與外參",
  "document.package.download": "下載原始 ZIP",
  "document.create": "新增文件",
  "revision.create": "上傳新版／同名更新",
  "document.meta.edit": "修改圖號／圖名／專業／樓層／extra",
  "revision.label.edit": "手動改版次代碼",
  "revision.status.edit": "修改版次狀態標籤",
  "revision.current.set": "指定現行版",
  "document.move": "搬移文件及歷程",
  "document.archive": "整份文件封存",
  "document.restore": "整份文件還原",
  "revision.purge": "永久刪除單一版次",
  "archive.read": "查看封存文件與佔用",
  "archive.purge": "永久刪除選定封存文件",
  "archive.purge_all": "清空封存匣",
  "catalog.export": "匯出 CSV",
  "catalog.import.preview": "預覽匯入差異",
  "catalog.import.apply": "寫入清冊資料",
  "project.create": "新增頂層目錄／專案",
  "project.rename": "專案改名",
  "project.delete": "刪除專案結構、搬移保留內容",
  "project.purge": "永久刪除專案及內容",
  "folder.create": "新增子目錄",
  "folder.rename": "目錄改名",
  "folder.move": "搬移目錄及其內容",
  "folder.delete": "刪目錄結構、保留／上移內容",
  "folder.purge": "永久刪除目錄子樹與文件",
  "rfi.read": "閱讀模型／文件頁面標點與提問",
  "rfi.create": "新增釋疑標點",
  "rfi.update": "編輯提問或釋疑位置",
  "rfi.delete": "刪除釋疑",
  "rfi.reply": "參與釋疑回覆",
  "annotation.read": "查看雲狀圖／箭頭／文字標註",
  "annotation.create": "新增標註",
  "annotation.update": "改文字／幾何／顏色／線寬",
  "annotation.delete": "刪除單筆標註",
  "annotation.resolve": "結案／重開標註",
  "annotation.reply": "寫入標註回覆",
  "annotation.clear": "清空整份標註",
  "viewpoint.read": "查看視點書籤",
  "viewpoint.create": "新增視點書籤",
  "viewpoint.update": "修改視點書籤名稱",
  "viewpoint.delete": "刪除視點書籤",
  "review.calibration.edit": "保存來源／顯示單位及尺度校正",
  "review.floors.edit": "新增／刪除共享樓層範圍",
  "workspace.read": "讀取共享對位／模型組合",
  "workspace.links.edit": "保存圖面關聯、控制點與樓層對位",
  "workspace.models.edit": "保存疊合模型與變換／顯示",
  "workspace.scale.edit": "保存 2D 尺度校正",
  "bim.properties.read": "讀取 ODA 原生構件屬性",
  "bim.levels.read": "讀取 RVT 原生樓層資料",
  "conversion.read": "看排程／失敗／轉檔狀態",
  "conversion.request": "單檔重轉／重試／外參重掃",
  "conversion.batch": "目錄批次／全部失敗重試",
  "conversion.stateless": "不進圖庫的 DWG／3D 轉換",
  "system.status.read": "查看詳細引擎／授權／快取／路徑",
  "library.usage.read": "查看圖庫統計與容量",
  "library.clear": "清空圖庫／未分類／指定目錄",
  "users.manage": "帳號管理（預留）",
  "roles.manage": "角色管理（預留）",
  "role_bindings.manage": "角色指派管理（預留）",
  "audit.read": "稽核查閱（預留）"
});
